module.exports = __webpack_public_path__ + "img/video.77ed5236.jpg";